module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.curInput,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仅允许一个部门"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.struct.select_type),
      expression: "curInput.struct.select_type"
    }],
    domProps: {
      "value": (_vm.curInput.struct.select_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.struct.select_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("否")])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasData),
      expression: "hasData"
    }],
    staticClass: "m-l-30",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.getStruct
    }
  }, [_vm._v("获取部门数据")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "允许选择范围"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.struct.select_range),
      expression: "curInput.struct.select_range"
    }],
    domProps: {
      "value": (_vm.curInput.struct.select_range)
    },
    on: {
      "input": function($event) {
        _vm.curInput.struct.select_range = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("用户所属部门")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 30
    }
  }, [_vm._v("自定义")])])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rangeShow),
      expression: "rangeShow"
    }],
    attrs: {
      "label": "选择范围"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedStructId),
      expression: "selectedStructId"
    }],
    attrs: {
      "multiple": "",
      "disabled": _vm.hasData,
      "placeholder": _vm.selectPlaceholder
    },
    domProps: {
      "value": (_vm.selectedStructId)
    },
    on: {
      "change": function($event) {
        _vm.selectRange()
      },
      "input": function($event) {
        _vm.selectedStructId = $event
      }
    }
  }, _vm._l((_vm.structData), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "默认选中值"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.struct.select_default),
      expression: "curInput.struct.select_default"
    }],
    domProps: {
      "value": (_vm.curInput.struct.select_default)
    },
    on: {
      "input": function($event) {
        _vm.curInput.struct.select_default = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("用户所属部门")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOwner),
      expression: "isOwner"
    }],
    attrs: {
      "label": 30
    }
  }, [_vm._v("自定义")])])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSingleDefault && _vm.isOwner),
      expression: "showSingleDefault && isOwner"
    }],
    attrs: {
      "label": "默认部门"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultStruct),
      expression: "defaultStruct"
    }],
    attrs: {
      "disabled": _vm.hasData,
      "placeholder": _vm.selectPlaceholder
    },
    domProps: {
      "value": (_vm.defaultStruct)
    },
    on: {
      "change": function($event) {
        _vm.selectStruct()
      },
      "input": function($event) {
        _vm.defaultStruct = $event
      }
    }
  }, _vm._l((_vm.selectedStruct), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMultiDefault),
      expression: "showMultiDefault"
    }],
    attrs: {
      "label": "默认部门"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultMultiStruct),
      expression: "defaultMultiStruct"
    }],
    attrs: {
      "multiple": "",
      "disabled": _vm.hasData,
      "placeholder": _vm.selectPlaceholder
    },
    domProps: {
      "value": (_vm.defaultMultiStruct)
    },
    on: {
      "change": function($event) {
        _vm.selectMultiStruct()
      },
      "input": function($event) {
        _vm.defaultMultiStruct = $event
      }
    }
  }, _vm._l((_vm.selectedStruct), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f472695!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/structConfig.vue
// module id = 1835
// module chunks = 2